<template>
	<div class="card mb-3">
		<img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
		<div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker
                                    v-model="inputDate" 
                                    :format="dateFormat" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <base-input alternative="" label="From Time"><br>
                                <a-time-picker use12Hours v-model="inputTimeFrom" format="h A" style="width: 100%" />
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <base-input alternative="" label="To"><br>
                                <a-time-picker use12Hours v-model="inputTimeTo" format="h A" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Terminal">
                                <!-- <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select> -->
                                <a-select v-model="inputTerminal" showSearch placeholder="Enter Terminal" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                     <!-- additional filter  -->
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Segment">
                                <a-select v-model="inputSegment" showSearch placeholder="All Segments" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                    <a-select-option v-for="option in segmentOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="isDelivery">
                        <div class="col-md-4">
                            <base-radio name="all_delivery" class="mb-3" v-model="deliveryOptions">
                                All Delivery
                            </base-radio>
                            <base-radio name="delivery_only" class="mb-3" v-model="deliveryOptions">
                                Delivery only
                            </base-radio>
                            <base-radio name="with_aggregator" class="mb-3" v-model="deliveryOptions">
                                Delivery with aggregators
                            </base-radio>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport" download="hourly_sales_by_segment_report.pdf">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="'hourly_sales_by_segment_report'">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" class="float-right"  style=" width: 20%;" name="hourly_sales_by_segment_report.xls">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import reportUtils from '../../components/reportUtils'

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputTerminal: 0,
                terminalOptions: [],
                terminalName: 'All Terminals',
                inputTimeFrom: moment('8 AM', 'h A'),
                inputTimeTo: moment('7 PM', 'h A'),
                birSalesReports: [],
                JsonData: [],
                dateFormat: 'MM/DD/YYYY',
                inputSegment: 0,
                segmentOptions: [],
                isDelivery: false,
                deliveryOptions: 'all_delivery',
            }
        },

        mounted: async function() {
            var component_x = this;

            var userId = secureStorage.getItem('userId');
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem('defaultSiteId');
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null);
            if (site != undefined) {
                this.site_type = site.site_type
            }
            this.inputSite = [siteId]

            var terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + this.inputSite.join(), null);
            component_x.terminalOptions = terminals;
            component_x.sort(component_x.terminalOptions);
            component_x.terminalOptions.unshift({id: 0, name: 'All Terminals'})

            // transaction types
            let transactionTypes = await HTTPRequest.getRequest(component_x.endPoint + "pos_transaction_types/get_valid_pos_transaction_types", null)
            component_x.segmentOptions = transactionTypes;
            component_x.segmentOptions.push({id: 0, name: 'All Segments'})
            component_x.sort(component_x.segmentOptions);
            component_x.inputSegment = 0
        },

        watch: {
            inputSegment: function (){
                let deliveryIndex = this.segmentOptions.find(x => x.name == 'Delivery')
                if(this.inputSegment == deliveryIndex.id){ 
                    this.isDelivery = true
                } else {
                    this.isDelivery = false
                    this.deliveryOptions = 'all_delivery'
                }
            },
            inputSite: async function () {
                this.inputTerminal = 0;
                var terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + this.inputSite.join(), null);
                this.terminalOptions = terminals;
                this.sort(this.terminalOptions);
                this.terminalOptions.unshift({id: 0, name: 'All Terminals'})
            },
            inputTerminal: function () {
                this.terminalName = this.terminalOptions.find(x => x.id == this.inputTerminal).name
            }
        },

        computed: {
            ...mapState(['endPoint']),
        },

        components: {
            VueJsonToCsv
        },

        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },

            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg
                });
            },

            sort(data) {
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },

            convertToCurrency(num) {
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },

            generateReport: async function() {
                if (this.inputDate.length == 0) {
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD');
                let to_date   = this.inputDate[1].format('YYYY-MM-DD');
                let time_from = this.inputTimeFrom.format('HH:mm');
                let time_to   = this.inputTimeTo.format('HH:mm');

                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A');
                let to_header   = this.inputDate[1].format('MMMM DD, YYYY hh:mm A');

                var segments = await HTTPRequest.getRequest(this.endPoint + 'hourly_sales_by_segment?site_id=' + this.inputSite + '&terminal_id=' + this.inputTerminal + '&group_by=' + '&date_from=' + from_date + '&date_to=' + to_date + '&time_from=' + time_from + '&time_to=' + time_to + '&segment=' + this.inputSegment + '&deliveryOptions=' + this.deliveryOptions, null);

                if(segments.error) {
                    this.openNotificationWithIcon('error', segments.error);
                    return
                }

                var siteSpecific = segments;
                var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                let reportLogo = document.getElementById('reportLogo');
                doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                let headers = []
                headers = [
                            [
                                {content: 'Transaction Type', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Time', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Sales', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Running', styles: {halign: 'center', valign: 'center'}},
                                {content: '% Contribution', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Transaction Count', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Average Check', styles: {halign: 'center', valign: 'center'}}
                            ]
                        ];

                for (let x = 0; x < siteSpecific.length; x++) {
                    this.birSalesReports = siteSpecific[x].report_details

                    var total_sales = 0
                    var total_transaction_count = 0
                    var running_value = 0
                    var percentage = 0
                    var total_total_sales = 0
                    var total_percentage = 0
                    var average_check = 0
                    let total_avg_check = 0.0
                    
                    if(x > 0 && this.birSalesReports.length > 0){
                        doc.addPage();
                    }

                    if (this.birSalesReports.length > 0) {
                        for (let i = 0; i < this.birSalesReports.length; i++) {
                            let reportLine = this.birSalesReports[i]

                            reportLine.forEach(element => {
                                total_sales += Number(element.INVOICE_AMOUNT);
                            });
                        }
                    }

                    let reportData = [];
                    if (this.birSalesReports.length > 0) {
                        for (let i = 0; i < this.birSalesReports.length; i++) {
                            let reportLine = this.birSalesReports[i]

                            reportLine.forEach(element => {
                                running_value += Number(element.INVOICE_AMOUNT) 
                                percentage = total_sales != 0 ? (Number(element.INVOICE_AMOUNT)/total_sales)*100 : 0.0

                                average_check = element.TRANSACTION_COUNT != 0 ? Number(element.INVOICE_AMOUNT/element.TRANSACTION_COUNT) : 0.0
                                
                                let selectedSegment = this.segmentOptions.find(x => x.id == this.inputSegment)
                                let segmentName = selectedSegment.name
                                element.TRANSACTION_TYPE =  segmentName == 'All Segments' ? element.TRANSACTION_TYPE : segmentName

                                let detail = [
                                    element.TRANSACTION_TYPE,
                                    element.SALE_HOURS,
                                    this.convertToCurrency(Number(element.INVOICE_AMOUNT)),
                                    this.convertToCurrency(running_value),
                                    percentage.toFixed(2) + '%',
                                    element.TRANSACTION_COUNT,
                                    average_check.toFixed(2)
                                ]

                                total_total_sales += Number(element.INVOICE_AMOUNT)
                                total_percentage += percentage
                                total_transaction_count += Number(element.TRANSACTION_COUNT)
                                total_avg_check += Number(average_check)

                                reportData.push(Object.assign({}, detail))
                            });

                            if(i == this.birSalesReports.length-1){
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(Object.assign({}, ['', '',
                                    this.convertToCurrency(Number(total_total_sales)),
                                    this.convertToCurrency(Number(running_value)),
                                    this.convertToCurrency(Number(total_percentage)) + '%',
                                    this.convertToCurrency(Number(total_transaction_count)),
                                    this.convertToCurrency(total_avg_check)
                                    // this.convertToCurrency(Number(Number(total_total_sales)/Number(total_transaction_count)))
                                ]));
                            }
                        }
                    }

                    doc.setFontSize(14);
                    doc.setFontType("bold");
                    doc.text(15,20,"Hourly Sales By Segment Report")
                    doc.setFontType("normal");
                    doc.setFontSize(10);
                    doc.text(300,20,siteSpecific[x].report_details[0][0].SITE_NAME);
                    doc.text(300,25,this.terminalName)
                    doc.text(15,25,"For the Period of " + from_header  + " to " + to_header)

                    doc.autoTable({
                        startY: 35, 
                        head: headers, 
                        body: reportData, 
                        theme: 'plain',
                        tableWidth: 'wrap',
                        headStyles: {
                            lineWidth: 0.15,
                            cellPadding: 2
                        },
                        styles: {
                            cellPadding: 1.0, fontSize: 10,
                            halign: 'right'
                        },
                        columnStyles: {
                            0: {cellWidth: 50},
                            1: {cellWidth: 50},
                            2: {cellWidth: 50},
                            3: {cellWidth: 50},
                            4: {cellWidth: 50},
                            5: {cellWidth: 50}
                        },
                        didParseCell: function(data) {
                            if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                data.cell.styles.fillColor = [0, 0, 0]
                                data.cell.styles.fontSize = 1
                                data.cell.styles.cellPadding = 0
                            } else if (data.row.section == 'body' && (data.row.raw[0] == '')){
                                data.cell.styles.fontStyle = 'bold'
                            }
                        }
                    });

                    // doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                    // doc.text(340,200,"Hourly Sales by Segment Report", "right")

                    // doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                    // doc.text(340,205,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                }
                let printed_by = secureStorage.getItem("email")
                if(printed_by == null){
                    printed_by = ''
                }

                let pageCount = doc.internal.getNumberOfPages();
                let design_x = 340
                let design_y =  205
                for(let i = 1; i <= pageCount; i++) { 
                    doc.setPage(i);
                    reportUtils.pdfTools.addFooter(doc, printed_by, "Hourly Sales by Segment Report", design_x, design_y, i, pageCount)
                }

                window.open(URL.createObjectURL(doc.output("blob")))
            }, 

            generateFile: async function() {
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'No records returned. Please make sure to check your filters.');
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD');
                let to_date   = this.inputDate[1].format('YYYY-MM-DD');
                let time_from = this.inputTimeFrom.format('HH:mm');
                let time_to   = this.inputTimeTo.format('HH:mm');

                let from_header = this.inputDate[0].format('MMMM DD, YYYY hh:mm A');
                let to_header   = this.inputDate[1].format('MMMM DD, YYYY hh:mm A');

                var segments = await HTTPRequest.getRequest(this.endPoint + 'hourly_sales_by_segment?site_id=' + this.inputSite + '&terminal_id=' + this.inputTerminal + '&date_from=' + from_date + '&date_to=' + to_date + '&time_from=' + time_from + '&time_to=' + time_to + '&segment=' + this.inputSegment + '&deliveryOptions=' + this.deliveryOptions, null);

                if(segments.error) {
                    this.openNotificationWithIcon('error', segments.error);
                    return
                }

                var siteSpecific = segments;

                if(segments.length > 0) {
                    let headers = []
                    let site_specific = []

                    headers = ['Transaction Type', 'Time', 'Sales', 'Running', '% Contribution', 'Transaction Count', 'Average Check']

                    for (let x = 0; x < siteSpecific.length; x++) {
                        this.birSalesReports = siteSpecific[x].report_details

                        var total_sales = 0
                        var total_transaction_count = 0
                        var running_value = 0
                        var percentage = 0
                        var total_total_sales = 0
                        var total_percentage = 0
                        var average_check = 0

                        if (this.birSalesReports.length > 0) {
                            for (let i = 0; i < this.birSalesReports.length; i++) {
                                let reportLine = this.birSalesReports[i]

                                reportLine.forEach(element => {
                                    total_sales += Number(element.INVOICE_AMOUNT);
                                });
                            }
                        }

                        let reportData = []

                        if (this.birSalesReports.length > 0) {
                            for (let i = 0; i < this.birSalesReports.length; i++) {
                                let reportLine = this.birSalesReports[i]

                                reportLine.forEach(element => {
                                    running_value += Number(element.INVOICE_AMOUNT) 
                                    percentage = total_sales != 0 ? (Number(element.INVOICE_AMOUNT)/total_sales)*100 : 0.0

                                    average_check = element.TRANSACTION_COUNT != 0 ? Number(element.INVOICE_AMOUNT/element.TRANSACTION_COUNT) : 0.0
                                    
                                    let selectedSegment = this.segmentOptions.find(x => x.id == this.inputSegment)
                                    let segmentName = selectedSegment.name
                                    element.TRANSACTION_TYPE =  segmentName == 'All Segments' ? element.TRANSACTION_TYPE : segmentName

                                    let detail = [
                                        element.TRANSACTION_TYPE,
                                        element.SALE_HOURS,
                                        this.convertToCurrency(Number(element.INVOICE_AMOUNT)),
                                        this.convertToCurrency(running_value),
                                        percentage.toFixed(2) + '%',
                                        element.TRANSACTION_COUNT,
                                        average_check.toFixed(2)
                                    ]

                                    total_total_sales += Number(element.INVOICE_AMOUNT)
                                    total_percentage += percentage
                                    total_transaction_count += Number(element.TRANSACTION_COUNT)

                                    reportData.push(Object.assign({}, detail))
                                });

                                if(i == this.birSalesReports.length-1){
                                    let total_avg_check = 0.0
                                     if(Number(total_total_sales) == 0.0 && Number(total_transaction_count) == 0.0){
                                        total_avg_check = 0.0
                                    } else {
                                        total_avg_check = Number(total_total_sales)/Number(total_transaction_count)
                                    }
                                    reportData.push(Object.assign({}, ['', '',
                                        this.convertToCurrency(Number(total_total_sales)),
                                        this.convertToCurrency(Number(running_value)),
                                        this.convertToCurrency(Number(total_percentage)) + '%',
                                        this.convertToCurrency(Number(total_transaction_count)),
                                        this.convertToCurrency(total_avg_check)
                                    ]));
                                }
                            }
                        }
                    
                    let site_text = ''
                    if (this.inputSite.length == 0) {
                        site_text = 'All Sites'
                    } else {
                        let sites = this.inputSite
                        for (var s = 0; s < sites.length; s++) {
                            let found_site = this.siteOptions.find(x => x.id === sites[s]);
                            if (found_site) {
                                if (s == 0) {
                                    site_text += found_site.name;
                                } else {
                                    site_text += ', ' + found_site.name;
                                }
                            }
                        }
                    }

                    // reportData.unshift([site_text]);
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    reportData.push([])
                    reportData.push(["Hourly Sales By Segment Report Generated By: " + printed_by,"For the Period of " + from_header  + " to " + to_header, "Branch: "+ site_text, "Terminal: " + this.terminalName]);
                    reportData.push([])

                    let keys = headers;
                    let values = reportData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                            [val]: values[i][index]
                        })));
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                            }
                        }
                    });
                    site_specific.push(newJsonData)
                    }
                    this.JsonData = site_specific.flat(Infinity);
                }
            },


            clearJsonData() {
                this.JsonData = [];
            },
        }
    }
</script>